import styled from '@emotion/styled';

const ShareDropdownContainer = styled('span')({
  float: 'right',
});

export default ShareDropdownContainer;
